/**
 * Created by mukund on 12/14/17.
 *
 * Webcam Capture Service
 */

'use strict';

angular.module('mediacloudApp')
    .factory('WebcamService',['$interval', '$resource', function($interval, $resource){

        var webRtcPeer,
            pipeline,
            recorder,
            client,
            recordingFilePath,
            timer,
            state,
            states,
            type,
            types;

        states = {
            IDLE: 'IDLE',
            STARTED: 'STARTED',
            RECORDING: 'RECORDING',
            STOPPED: 'STOPPED',
            REVIEWING: 'REVIEWING',
            REVIEWED: 'REVIEWED'
        };

        types = {
            AUDIO: 'AUDIO',
            VIDEO: 'VIDEO'
        };

        var getOpts = function(args, opts) {
            var result = opts.default || {};
            args.replace(
                new RegExp("([^?=&]+)(=([^&]*))?", "g"),
                function ($0, $1, $2, $3) {
                    result[$1] = decodeURI($3);
                });

            return result;
        };

        var args = getOpts(location.search, {
            default: {
                ws_uri: 'wss://kurento-ss-dev.us-east-1.prod.sharestream.com/kurento',
                file_uri: 'file:///kurento/'
            }
        });

        var constraints = {
            audio: true,
            video: {
                width: 1280
            }
        };

        var disposeWebRTCPeer = function(){
            if(webRtcPeer) {
                webRtcPeer.dispose();
                console.log("webRTCPeer disposed...");
                webRtcPeer = null;
            }
        };

        var releasePipeline = function(){
            if(pipeline) {
                pipeline.release();
                console.log("Pipeline released...");
                pipeline = null;
            }
        };

        var disposeWebcam = function(){
            console.log("Disposing webRtcPeer and pipeline if set up...");
            disposeWebRTCPeer();
            releasePipeline();
        };

        var onError = function(error) {
            if (error) {
                console.error(error);
                disposeWebRTCPeer();
                releasePipeline();
                // Error code for Safari iframe issue
                if(error.code === 35){
                    console.log("Webcam capture not allowed due to missing iframe attributes...");
                }
            }
        };

        var setIceCandidateCallbacks = function(webRtcPeer, webRtcEp, onError) {
            console.log("Setting Ice Candidate Callbacks...");
            if(webRtcPeer) {
                webRtcPeer.on('icecandidate', function (candidate) {
                    candidate = kurentoClient.getComplexType('IceCandidate')(candidate);
                    webRtcEp.addIceCandidate(candidate, onError)
                });
                webRtcEp.on('OnIceCandidate', function (event) {
                    var candidate = event.candidate;
                    webRtcPeer.addIceCandidate(candidate, onError);
                });
            }
        };

        var onStartOffer = function(error, sdpOffer) {
            console.log("Generating start offer for remote stream...");
            if (error) {
                console.log("An error occurred when generating start offer for remote stream...");
                return onError(error);
            }
            co(function*() {
                try {
                    if (!client) {
                        client = yield kurentoClient(args.ws_uri);
                    }
                    pipeline = yield client.create('MediaPipeline');
                    var webRtc = yield pipeline.create('WebRtcEndpoint');
                    webRtc.setMaxVideoRecvBandwidth(5000);
                    setIceCandidateCallbacks(webRtcPeer, webRtc, onError);
                    if (type === 'AUDIO'){
                        recorder = yield pipeline.create('RecorderEndpoint', {uri: recordingFilePath,  mediaProfile: 'WEBM_AUDIO_ONLY'});
                    }
                    else{
                        recorder = yield pipeline.create('RecorderEndpoint', {uri: recordingFilePath});
                    }
                    console.log("The recording will be written to uri: " + recordingFilePath);
                    yield webRtc.connect(recorder, function(error){
                        if(error) {
                            console.log("An error occurred when connecting WebRtcEndpoint to RecorderEndpoint...");
                            return onError(error);
                        }
                        console.log("Connected WebRtcEndpoint to RecorderEndpoint...");
                    });
                    yield webRtc.connect(webRtc, function(error){
                        if(error) {
                            console.log("An error occurred when establishing loopback to WebRtcEndpoint...");
                            return onError(error);
                        }
                        console.log("Established loopback to WebRtcEndpoint...");
                    });
                    yield recorder.record(function(error){
                        if(error) {
                            console.log("An error occurred when recording remote stream...");
                            return onError(error);
                        }
                        console.log("Started recording remote stream...");
                        state = states.RECORDING;
                    });
                    var sdpAnswer = yield webRtc.processOffer(sdpOffer);
                    console.log("Generated SDP Answer: " + sdpAnswer);
                    webRtc.gatherCandidates(onError);
                    if(webRtcPeer) {
                        webRtcPeer.processAnswer(sdpAnswer, onError);
                    }
                } catch(e) {
                    console.log("An error occurred when generating start offer for remote stream...");
                    onError(e);
                }
            })();
        };

        var onPlayOffer = function(error, sdpOffer) {
            console.log("Generating play offer for remote stream...");
            if (error) {
                console.log("An error occurred when generating play offer for remote stream...");
                return onError(error);
            }
            co(function*() {
                try {
                    if (!client) {
                        client = yield kurentoClient(args.ws_uri);
                    }
                    pipeline = yield client.create('MediaPipeline');
                    var webRtc = yield pipeline.create('WebRtcEndpoint');
                    webRtc.setMaxVideoRecvBandwidth(5000);
                    setIceCandidateCallbacks(webRtcPeer, webRtc, onError);
                    var player = yield pipeline.create('PlayerEndpoint', {uri: recordingFilePath});
                    console.log("The recording will be played back from uri: " + recordingFilePath);
                    player.on('EndOfStream', disposeWebcam);
                    yield player.connect(webRtc, function(error){
                        if(error) {
                            console.log("An error occurred when connecting WebRtcEndpoint to PlayerEndpoint...");
                            return onError(error);
                        }
                        console.log("Connected WebRtcEndpoint to PlayerEndpoint...");
                    });
                    var sdpAnswer = yield webRtc.processOffer(sdpOffer);
                    webRtc.gatherCandidates(onError);
                    if(webRtcPeer) {
                        webRtcPeer.processAnswer(sdpAnswer, onError);
                    }
                    yield player.play(function(error){
                        if(error) {
                            console.log("An error occurred when playing recording...");
                            return onError(error);
                        }
                        console.log("Playing recording...");
                        state = states.REVIEWING;
                    });
                }
                catch (e) {
                    console.log("An error occurred when generating play offer for remote stream...");
                    onError(e);
                }
            })();
        };

        var pad = function(str, max) {
            str = str.toString();
            return str.length < max ? pad("0" + str, max) : str;
        };

        var startTimer = function(timerElt){
            var sec = 0, min = 0, hour = 0;
            timer = $interval(function () {
                sec++;
                if(sec == 59) {
                    min++;
                    sec = 0;
                }
                if(min == 59) {
                    hour++;
                    min = 0;
                }
                timerElt.text(pad(hour, 2) + " : " + pad(min, 2) + " : " + pad(sec, 2));
            }, 1000);
        };

        return {

            isSupported: function(){
                var supported = true;

                // Check if WebRTC is not supported
                // MS Edge & IE 11 blocked
                if(!navigator.getUserMedia || navigator.userAgent.indexOf("Edge") >= 0 || navigator.userAgent.indexOf(".NET") >= 0 || navigator.userAgent.indexOf("Firefox") >= 0){
                    supported = false;
                } else if(self !== top){
                    // Check for viewing inside iframe
                    // Safari blocked
                    if(navigator.userAgent.indexOf("Safari") >= 0 && navigator.userAgent.indexOf("Chrome") < 0){
                        supported = false;
                    }
                }
                return supported;
            },

            isIdle: function(){
                return state === states.IDLE;
            },

            isStarted: function(){
                return state === states.STARTED;
            },

            isRecording: function(){
                return state === states.RECORDING;
            },

            isStopped: function(){
                return state === states.STOPPED;
            },

            isReviewing: function(){
                return state === states.REVIEWING;
            },

            getType: function(){
                return type;
            },

            setType: function(value){
                if(types.hasOwnProperty(value)){
                    type = value;
                }
            },

            getState: function(){
                return state;
            },

            setState: function(value){
                if(states.hasOwnProperty(value)){
                    state = value;
                }
            },

            getRecordingFilePath: function(){
                var webcamCaptureId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
                recordingFilePath = args.file_uri + "recording_" + webcamCaptureId + '.webm';
                console.log("The recording will be saved to: " + recordingFilePath);
                return recordingFilePath;
            },

            startLocalStream: function(localVideoElt){
                console.log("Starting Local Stream...");
                if(type === 'AUDIO'){
                    constraints.video = false;
                } else {
                    constraints.video = {
                        width: 1280
                    }
                }
                var options = {
                    localVideo: localVideoElt,
                    mediaConstraints: constraints
                };
                webRtcPeer = kurentoUtils.WebRtcPeer.WebRtcPeerSendrecv(options, function(error) {
                    if(error) {
                        console.log("An error occurred when starting local stream...");
                        return onError(error);
                    }
                    console.log("Local Stream started with options: " + JSON.stringify(options, null, 4));
                    state = states.STARTED;
                });
            },

            startRecording: function(remoteVideoElt, timerElt){
                console.log("Starting Recording...");
                remoteVideoElt.muted = true;
                console.log("Stopping Local Stream...");
                // Stop the Local Stream
                disposeWebRTCPeer();
                console.log("Local Stream has been stopped...");
                var options = {
                    remoteVideo: remoteVideoElt,
                    mediaConstraints: constraints
                };
                // Start the Remote Stream
                webRtcPeer = kurentoUtils.WebRtcPeer.WebRtcPeerSendrecv(options, function(error) {
                    if(error) {
                        console.log("An error occurred when starting remote stream...");
                        return onError(error);
                    }
                    console.log("Starting remote stream recording with options: " + JSON.stringify(options, null, 4));
                    this.generateOffer(onStartOffer);
                    startTimer(timerElt);
                });
            },

            stopRecording: function(){
                console.log("Stopping Recording...");
                if(timer){
                    $interval.cancel(timer);
                }
                recorder.stopAndWait(function(){
                    disposeWebcam();
                    console.log("Recording ready for review...");
                    state = states.STOPPED;
                });
            },

            playRecording: function(videoReviewElt, localVideoElt){
                videoReviewElt.muted = false;
                var options =
                {
                    localVideo: localVideoElt,
                    remoteVideo: videoReviewElt
                };
                webRtcPeer = kurentoUtils.WebRtcPeer.WebRtcPeerRecvonly(options, function (error) {
                    if (error) {
                        console.log("An error occurred when playing back remote stream recording...");
                        return onError(error);
                    }
                    console.log("Playing back remote stream recording with options: " + JSON.stringify(options, null, 4));
                    this.generateOffer(onPlayOffer);
                });
            },

            destroyWebcam: function(){
                disposeWebcam();
                state = states.IDLE;
            },

            saveRecording: $resource('api/recording/save')

        }
    }]);
